import React, { Children, useEffect, useState } from 'react';
import { Drawer, Button, Form, Card, Spin, Input, Checkbox, DatePicker, Space, Select, Tooltip, Avatar } from 'antd';
import { MailOutlined, InfoCircleOutlined, PhoneOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import ApiService from '../Components/apiService'; // Import ApiService class
import { BASE_URL, DateFormat, DateTimeFormat } from '../Components/Constant'; // Define the date format
import customParseFormat from 'dayjs/plugin/customParseFormat';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DynamicSelect from './DynamicSelectForLookup';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { convertToDateJSON } from '../Components/Utility';
import CustomDrawer from '../Components/CustomDrawer';
import ChatEditor from '../ChatTextEditor/ChatEditor';


dayjs.extend(customParseFormat);

const CreateRecordDrawer = ({
  visible,
  onClose,
  onFinish,
  loading,
  fieldsData,
  selectedRecord,
  selectedDate,
  setSelectedDate,
  handleFinishFailed,
  objectName,
  relatedObject,
  form,
  isRelatedCreate,
  isFieldReadOnly,
  logbook,
  isFromRelatedRecord,
  currentRelatedList

}) => {
  const [lookupOptionforparent, setLookupOptionsForParent] = useState([]);
  const [richTextContent, setRichTextContent] = useState('');
  const security = useSelector(state => state.data.items[0]);
  const [currency, setCurrency] = useState('');
  const defaultCurrency = useSelector(state => state.data.orgItem);
  const loginUserCurrency = Cookies.get('userCurrency');

  const currUserId = Cookies.get('userId');
  const currUserName = Cookies.get('name');

  console.log('current', currentRelatedList);

  const fetchOrgSetupDetails = async () => {
    console.log('currency:::', defaultCurrency);
    setCurrency(defaultCurrency?.currency);

  };

  useEffect(() => {
    console.log('loginUserCurrencyloginUserCurrency:', loginUserCurrency);
    fetchOrgSetupDetails();
  }, []);


  useEffect(() => {
    if (selectedRecord) {
      // Populate the form with selected record's data
      const formValues = {};
      fieldsData.forEach(field => {
        if (field.type === 'date' || field.type === 'datetime') {
          formValues[field.name] = selectedRecord[field.name]
            ? dayjs(selectedRecord[field.name], field.type === 'date' ? DateFormat : DateTimeFormat)
            : null;
        } else if (field.type === 'boolean') {
          formValues[field.name] = selectedRecord[field.name] || false;
        } else if (field.type === 'address') {
          // Assuming address fields are stored as separate properties
          formValues[`${field.name}_street`] = selectedRecord[`${field.name}_street`] || '';
          formValues[`${field.name}_city`] = selectedRecord[`${field.name}_city`] || '';
          formValues[`${field.name}_state`] = selectedRecord[`${field.name}_state`] || '';
          formValues[`${field.name}_country`] = selectedRecord[`${field.name}_country`] || '';
          formValues[`${field.name}_postalcode`] = selectedRecord[`${field.name}_postalcode`] || '';
        } else if (field.type === 'richtext') {
          formValues[field.name] = selectedRecord[field.name] || '';
        } else {
          formValues[field.name] = selectedRecord[field.name] || '';
        }
      });
      form.setFieldsValue(formValues);
    } else {
      if (isRelatedCreate === undefined || isRelatedCreate === null || isRelatedCreate === false) {
        form.resetFields();
        const value = {
          _id: currUserId,
          Name: currUserName,
        }
        form.setFieldsValue({ User: value });
      }
      if (isRelatedCreate) {
        const value = {
          _id: currUserId,
          Name: currUserName,
        }
        form.setFieldsValue({ User: value });
      }
      if (selectedDate) {
        form.setFieldsValue({ Date: dayjs(selectedDate, DateFormat) });
      }


      setRichTextContent(''); // Reset the form if no record is selected (for new record)
    }
  }, [selectedRecord, form, fieldsData]);

  const handleSearch = async (value, fieldId, name, callback) => {
    const allFields = form.getFieldsValue();

    const filteredFields = Object.entries(allFields)
      .filter(([key, fieldValue]) => key !== name)
      .reduce((acc, [key, fieldValue]) => {
        acc[key] = fieldValue;
        return acc;
      }, {});
    if (value) {
      try {
        const apiService = new ApiService(`${BASE_URL}/search_lookup/${fieldId}/${value}`, {
          'Content-Type': 'application/json', // Add any necessary headers, such as content type
        }, 'POST', { child_context: selectedRecord ? selectedRecord : filteredFields });
        const response = await apiService.makeCall();
        // Assuming the response data structure has options as an array
        setLookupOptionsForParent(prevOptions => ({
          ...prevOptions,
          [name]: response // Store the response for the specific field name
        }));
      } catch (error) {
        setLookupOptionsForParent(prevOptions => ({
          ...prevOptions,
          [name]: []
        }));
      } finally {
        callback();
      }
    } else {
      setLookupOptionsForParent(prevOptions => ({
        ...prevOptions,
        [name]: []
      }));
      callback();
    }
  };


  const renderFormItem = (field) => {

    if (field.is_auto_number || field.is_formula || field.type === 'rollup') {
      return null;
    }

    if (field.name === 'recordCount' || field.name === 'CreatedBy' || field.name === 'LastModifiedBy') {
      return null;
    }

    const isDisable = selectedRecord?.id ? !security?.object_settings?.[objectName]?.field_setting?.[field?.name]?.edit : !security?.object_settings?.[objectName]?.field_setting?.[field?.name]?.create;


    const isRequired = field.required ? [{ required: true, message: `${field.label} is required!` }] : [];

    // Check if help text is present for the field
    const renderLabel = (
      <span>
        {field.label}
        {field.help_text && field.help_text.trim() !== "" && (
          <Tooltip title={field.help_text}>
            <InfoCircleOutlined style={{ marginLeft: 8, color: '#1890ff' }}></InfoCircleOutlined>
          </Tooltip>
        )}
      </span>
    );

    switch (field.type) {
      case 'string':
        return (
          <Form.Item
            key={field.name}
            name={field.name}
            label={renderLabel}  // Use the custom label here
            rules={isRequired}
          >
            <Input placeholder={`Enter ${field.label}`} disabled={isDisable} />
          </Form.Item>
        );

      case 'integer':
        return (
          <Form.Item
            key={field.name}
            name={field.name}
            label={renderLabel}  // Use the custom label here
            rules={isRequired}
          >
            <Input type="number" placeholder={`Enter ${field.label}`} disabled={isDisable} />
          </Form.Item>
        );

      case 'phone':
        return (
          <Form.Item
            key={field.name}
            name={field.name}
            label={renderLabel} // Use the custom label here
            rules={isRequired}

          >
            <Input
              placeholder={`Enter ${field.label}`}
              disabled={isDisable}
              addonBefore={
                <PhoneOutlined style={{ cursor: 'pointer' }} />
              }
            />
          </Form.Item>
        );

      case 'email':
        return (
          <Form.Item
            key={field.name}
            name={field.name}
            label={renderLabel}  // Use the custom label here
            rules={[
              { type: 'email', message: 'The input is not valid E-mail!' },
              ...isRequired
            ]}
          >
            <Input type='email' prefix={<MailOutlined />} placeholder="Enter email" disabled={isDisable} />
          </Form.Item>
        );

      case 'boolean':
        return (
          <Form.Item
            key={field.name}
            name={field.name}
            valuePropName="checked"
            initialValue={false}
          // label={renderLabel}  // Use the custom label here
          >
            <Checkbox disabled={isDisable}>{field.label}</Checkbox>
          </Form.Item>
        );

      case 'date':
        return (
          <Form.Item
            key={field.name}
            name={field.name}
            label={renderLabel}  // Use the custom label here
            rules={isRequired}
          >
            <Space>
              <DatePicker
                placeholder={`Select ${field.label}`}
                style={{ width: '100%' }}
                format={DateFormat}
                value={
                  form.getFieldValue(field.name)
                    ? convertToDateJSON(form.getFieldValue(field.name), DateFormat)
                    : null
                }
                onChange={(date, dateString) => {
                  setSelectedDate(date ? dayjs(dateString, DateFormat) : null);
                  form.setFieldsValue({ [field.name]: dateString });
                }}
                disabled={logbook || isDisable}
              />
            </Space>
          </Form.Item>
        );

      case 'datetime':
        return (
          <Form.Item
            key={field.name}
            name={field.name}
            label={renderLabel}  // Use the custom label here
            rules={isRequired}
          >
            <Space>
              <DatePicker
                showTime
                placeholder={`Select ${field.label}`}
                style={{ width: '100%' }}
                disabled={isDisable}
                format={DateTimeFormat}
                value={form.getFieldValue(field.name) ? dayjs(form.getFieldValue(field.name), DateTimeFormat) : null}
                onChange={(date, dateString) => {
                  setSelectedDate(date ? dayjs(dateString, DateTimeFormat) : null);
                  form.setFieldsValue({ [field.name]: dateString });
                }}
              />
            </Space>
          </Form.Item>
        );

      case 'url':
        return (
          <Form.Item
            key={field.name}
            name={field.name}
            label={renderLabel}  // Use the custom label here
            rules={[
              { type: 'url', message: 'Please enter a valid URL!' },
              ...isRequired
            ]}
          >
            <Input type="url" placeholder={`Enter ${field.label}`} disabled={isDisable} />
          </Form.Item>
        );

      case 'currency':
        const currencyDecimalPlacesBefore = field.decimal_places_before;
        const currencyDecimalPlacesAfter = field.decimal_places_after;
        const regexPattern = new RegExp(`^\\d{1,${currencyDecimalPlacesBefore}}(\\.\\d{0,${currencyDecimalPlacesAfter}})?$`);
        const handleCurrencyInput = (event) => {
          const inputValue = event.target.value;
          if (!regexPattern.test(inputValue)) {
            event.preventDefault();
          }
        };

        return (
          <Form.Item
            key={field.name}
            name={field.name}
            label={renderLabel}  // Use the custom label here
            rules={isRequired}
          // initial={loginUserCurrency}
          >
            <Input
              // addonBefore={currency || '$'}
              placeholder={`Enter ${field.label}`}
              onInput={handleCurrencyInput}
              disabled={isDisable}
              maxLength={currencyDecimalPlacesBefore + currencyDecimalPlacesAfter + 1}
            />
          </Form.Item>
        );

      case 'picklist':
        return (
          <Form.Item
            key={field.name}
            name={field.name}
            label={renderLabel}
            rules={[
              ...(field.name === 'CurrencyIsoCode' ? [{ required: true, message: 'Currency is required' }] : []),
              ...isRequired
            ]}
            initialValue={field.name === 'CurrencyIsoCode' ? loginUserCurrency : undefined}
          >
            <Select
              placeholder={`Select ${field.label}`}
              allowClear
              disabled={isDisable}
            >
              {field.picklist_values.map((value) => (
                <Select.Option key={value} value={value}>
                  {value}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        );



      case 'multiselect':
        return (
          <Form.Item
            key={field.name}
            name={field.name}
            label={renderLabel}  // Use the custom label here
            rules={isRequired}
          >
            <Select
              mode="multiple"
              placeholder={`Select ${field.label}`}
              allowClear
              disabled={isDisable}
            >
              {field.picklist_values.map((value) => (
                <Select.Option key={value} value={value}>
                  {value}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        );

      case 'lookup':
        return (
          <Form.Item
            key={field.name}
            name={field.name}
            label={renderLabel}
            rules={isRequired}
          >
            <DynamicSelect
              objectName={field.parent_object_name}
              lookupConfig={field.lookup_config}
              onSearch={handleSearch}
              value={form.getFieldValue(field.name)}
              name={field.name}
              lookupOptionforparent={lookupOptionforparent}
              isFieldReadOnly={isFieldReadOnly}
              fieldId={field._id}
              onChange={(newValue) => form.setFieldsValue({ [field.name]: newValue })} // Update form value dynamically
              disabled={isDisable}
            />
          </Form.Item>
        );

      case 'address':
        return (
          <Form.Item
            key={field.name}
            name={field.name}
            label={field.label}
          >
            <Card title="Enter Address" bordered={true}>
              <Form.Item
                key={`${field.name}_street`}
                name={`${field.name}_street`}
                label="Street"
              >
                <Input placeholder="Enter Street" disabled={isDisable}
                />
              </Form.Item>
              <Form.Item
                key={`${field.name}_city`}
                name={`${field.name}_city`}
                label="City"
              >
                <Input placeholder="Enter City" disabled={isDisable} />
              </Form.Item>
              <Form.Item
                key={`${field.name}_state`}
                name={`${field.name}_state`}
                label="State"
              >
                <Input placeholder="Enter State" disabled={isDisable} />
              </Form.Item>
              <Form.Item
                key={`${field.name}_country`}
                name={`${field.name}_country`}
                label="Country"
              >
                <Input placeholder="Enter Country" disabled={isDisable} />
              </Form.Item>
              <Form.Item
                key={`${field.name}_postalcode`}
                name={`${field.name}_postalcode`}
                label="Postal Code"
              >
                <Input placeholder="Enter Postal Code" disabled={isDisable} />
              </Form.Item>
            </Card>
          </Form.Item>
        );

      case 'decimal':
        const decimalPlacesBefore = field.decimal_places_before;
        const decimalPlacesAfter = field.decimal_places_after;
        const decimalPattern = new RegExp(`^\\d{1,${decimalPlacesBefore}}(\\.\\d{0,${decimalPlacesAfter}})?$`);

        return (
          <Form.Item
            key={field.name}
            name={field.name}
            label={renderLabel}  // Use the custom label here
            rules={isRequired}
          >
            <Input
              placeholder={`Enter ${field.label}`}
              maxLength={decimalPlacesBefore + decimalPlacesAfter + 1}
              disabled={isDisable}
              onInput={(e) => {
                const value = e.target.value;
                if (!decimalPattern.test(value)) {
                  e.preventDefault();
                }
              }}
            />
          </Form.Item>
        );

      case 'percentage':
        return (
          <Form.Item
            key={field.name}
            name={field.name}
            label={renderLabel}
            rules={isRequired}
          >
            <Input addonAfter="%" type="float" placeholder={`Enter ${field.label}`} disabled={isDisable} />
          </Form.Item>
        );

      case 'textarea':
        return (
          <Form.Item
            key={field.name}
            name={field.name}
            label={renderLabel}  // Use the custom label here
            rules={isRequired}
          >
            <Input.TextArea
              placeholder={`Enter ${field.label}`}
              disabled={isDisable}
            />
          </Form.Item>
        );

      case 'image':
        return (
          <Form.Item
            key={field.name}
            name={field.name}
            label={renderLabel}  // Use the custom label here
            rules={[
              { type: 'url', message: 'Please enter a valid image URL!' },
              ...isRequired
            ]}
          >
            <Input type="url" placeholder={`Enter ${field.label} URL`} disabled={isDisable} />
          </Form.Item>
        );

      case 'richtext':
        return (
          <Form.Item
            key={field.name}
            name={field.name}
            label={renderLabel}
            rules={isRequired}
          >
         
             <ChatEditor 
                                onRichTextSaved={ (html)=>{
                                    const content=  String(html || '');
                                    form.setFieldsValue({ [field.name]: content });
                                    // setRichTextValues(prev=>({
                                    //     ...prev,
                                    //     [field.name]:content
                                    // }));
                                    console.log(form.getFieldValue(field.name));
                                }}
                                showTools={true}
                                placeholder={"Write here..."}   
                                prefill={form.getFieldValue(field.name) || ''}
                                editMode={true}
                                isRichTextField={true}
                            />
          </Form.Item>
        )

      default:
        return null;
    }
  };

  const cancelDrawer = () => {
    form.resetFields();
    onClose();
  }
  return (
    <CustomDrawer
      title={selectedRecord?.isClone
        ? 'Clone Record'
        : selectedRecord
          ? 'Edit Record'
          : logbook
            ? 'Create Log Record'
            : 'Create New Record'}
      visible={visible}
      onClose={!loading ? cancelDrawer : null} // Prevent drawer from closing when loading is true
      closable={false}
      footer={
        <div style={{ display: "flex", justifyContent: "space-between", padding: '8px'  }}>
          <Button onClick={onClose} >Cancel</Button>
          <div>
          </div>
          <div>
            {!logbook && (
              <Button
                style={{ marginRight: '16px' }}
                onClick={() => {
                  form.validateFields().then((values) => {
                    onFinish(values, true, isFromRelatedRecord ? currentRelatedList : null);
                  });
                }}
                disabled={loading}
                type="primary"
              >
                Save & New
              </Button>
            )}
            <Button
              onClick={() => form.submit()}
              disabled={loading} // Disable save button when loading is true
              type="primary"
            >
              Save
            </Button>
          </div>
        </div>
      }

    >
      <Spin spinning={loading} tip="Loading...">

        <Form
          form={form}
          layout="vertical"
          onFinish={(values) => {
            console.log('vallleuesss', values);
            const richTextValue = richTextContent; // Get the rich text content
            const formData = { ...values, richText: richTextValue };
            console.log('formdata:', formData);
            onFinish(formData); // Pass the full data to the parent
          }}
          onFinishFailed={handleFinishFailed} // Add this for handling validation errors
          style={{ fontSize: '16px' }}
        >
          {fieldsData?.map((field) => renderFormItem(field))}
        </Form>

      </Spin>
    </CustomDrawer>
  );
};

export default CreateRecordDrawer;